import React from 'react'
import { useState, useEffect } from "react";

function GetWidth() {
  const [GetWidth, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return GetWidth;
}

export default GetWidth